<template>
	<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
		<CIPFlowModal
			v-if="selectedFlow"
			:call-data="selectedFlowData"
			:completed="selectedFlowIsCompleted"
			refresh-interval="1000"
			:readonly="true"
			@close="selectedFlow = null"
		/>
		<div class="row hideMobile">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 tableOverflow">
				<div class="listHeader">
					<div class="row">
						<div class="col-xs-12 col-sm-1">
							<p class="cursor-pointer" @click="sortBy('queue_start_epoch')">
								Start Time <span :class="getSortIcon('queue_start_epoch')" class="ml-1"></span>
							</p>
						</div>
						<div
							v-if="tenants.length > 1 || $global.hasUserRole(userRoles, 'reseller')"
							class="col-xs-12 col-sm-2"
						>
							<p class="cursor-pointer" @click="sortBy('tenant')">
								Tenant <span :class="getSortIcon('tenant')" class="ml-1"></span>
							</p>
						</div>
						<div class="col-xs-12 col-sm-2">
							<p class="cursor-pointer" @click="sortBy('account')">
								Account <span :class="getSortIcon('account')" class="ml-1"></span>
							</p>
						</div>
						<div class="col-xs-12 col-sm-1">
							<p class="cursor-pointer" @click="sortBy('callFrom')">
								Call From <span :class="getSortIcon('callFrom')" class="ml-1"></span>
							</p>
						</div>
						<div class="col-xs-12 col-sm-1">
							<p class="cursor-pointer" @click="sortBy('callTo')">
								Call To <span :class="getSortIcon('callTo')" class="ml-1"></span>
							</p>
						</div>
						<div class="col-xs-12 col-sm-1">
							<p class="cursor-pointer" @click="sortBy('queueTime')">
								Queue Time <span :class="getSortIcon('queueTime')" class="ml-1"></span>
							</p>
						</div>
						<div class="col-xs-12 col-sm-2">
							<p class="cursor-pointer" @click="sortBy('flow')">
								Flow <span :class="getSortIcon('flow')" class="ml-1"></span>
							</p>
						</div>
						<div class="col-xs-12 col-sm-2">
							<p class="cursor-pointer" @click="sortBy('reference')">
								Reference <span :class="getSortIcon('reference')" class="ml-1"></span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-for="call in sortedQueuedCalls" :key="call.id" class="card listItem">
			<div class="row content middle-sm middle-md middle-lg">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
					<div class="row middle-sm middle-md middle-lg tableOverflow">
						<div class="col-xs-12 col-sm-1">
							<span class="block text-xs font-semibold uppercase text-[#999999] sm:hidden"
								>Start Time:</span
							>
							<p class="mb-4 overflow-hidden text-ellipsis sm:mb-0">
								{{ formatStartTime(call.queue_start_epoch) }}
							</p>
						</div>
						<div
							v-if="tenants.length > 1 || $global.hasUserRole(userRoles, 'reseller')"
							class="col-xs-12 col-sm-2"
						>
							<span class="block text-xs font-semibold uppercase text-[#999999] sm:hidden">Tenant:</span>
							<p class="mb-4 overflow-hidden text-ellipsis sm:mb-0">
								{{ call.tenant?.companyName || 'Unknown' }}
							</p>
						</div>
						<div class="col-xs-12 col-sm-2">
							<span class="block text-xs font-semibold uppercase text-[#999999] sm:hidden">Account:</span>
							<p class="mb-4 overflow-hidden text-ellipsis sm:mb-0">
								{{ call.callLeg?.accountName || 'Unknown' }}
							</p>
						</div>
						<div class="col-xs-12 col-sm-1">
							<span class="block text-xs font-semibold uppercase text-[#999999] sm:hidden"
								>Call From:</span
							>
							<p class="mb-4 overflow-hidden text-ellipsis sm:mb-0">
								{{ call.callLeg?.callFrom || 'Unknown' }}
							</p>
						</div>
						<div class="col-xs-12 col-sm-1">
							<span class="block text-xs font-semibold uppercase text-[#999999] sm:hidden">Call To:</span>
							<p class="mb-4 overflow-hidden text-ellipsis sm:mb-0">
								{{ call.callLeg?.callTo || 'Unknown' }}
							</p>
						</div>
						<div class="col-xs-12 col-sm-1">
							<span class="block text-xs font-semibold uppercase text-[#999999] sm:hidden"
								>Queue Time:</span
							>
							<p class="mb-4 overflow-hidden text-ellipsis sm:mb-0">
								{{ formatQueueTime(call.queue_start_epoch) }}
							</p>
						</div>
						<div class="col-xs-12 col-sm-2">
							<span class="block text-xs font-semibold uppercase text-[#999999] sm:hidden">Flow:</span>
							<p
								class="mb-4 cursor-pointer overflow-hidden text-ellipsis text-blue-500 hover:text-blue-700 sm:mb-0"
								@click="showFlowHistory(call.callLeg)"
							>
								{{
									call.callLeg?.flowHistory?.flows?.length
										? call.callLeg?.flowHistory?.flows[call.callLeg?.flowHistory?.flows?.length - 1]
												.flow.name
										: 'Unknown'
								}}
							</p>
						</div>
						<div class="col-xs-12 col-sm-2">
							<span class="block text-xs font-semibold uppercase text-[#999999] sm:hidden"
								>Reference:</span
							>
							<p class="mb-4 overflow-hidden text-ellipsis sm:mb-0">
								{{ call.flow_node || call.shared_ref || 'Unknown' }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="!queuedCalls || !queuedCalls.length" class="card no-action listItem orange">
			<div class="row content middle-sm middle-md middle-lg">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
					<div class="row middle-sm middle-md middle-lg">
						<div class="col-xs-12">
							<p>No queued calls found.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CIPFlowModal from './CIPFlowModal.vue'

export default {
	components: {
		CIPFlowModal
	},
	inject: ['user', 'userRoles', 'tenants'],
	props: ['queuedCalls', 'callLegs'],
	data() {
		return {
			selectedFlow: null,
			lastCallData: null,
			sortField: 'queue_start_epoch',
			sortDirection: 'desc'
		}
	},
	computed: {
		sortedQueuedCalls() {
			return [...this.queuedCalls].sort((a, b) => {
				let comparison = 0
				switch (this.sortField) {
					case 'queue_start_epoch':
						comparison = a.queue_start_epoch - b.queue_start_epoch
						break
					case 'tenant':
						comparison = (a.tenant?.companyName || '').localeCompare(b.tenant?.companyName || '')
						break
					case 'account':
						comparison = (a.callLeg?.accountName || '').localeCompare(b.callLeg?.accountName || '')
						break
					case 'callFrom':
						comparison = (a.callLeg?.callFrom || '').localeCompare(b.callLeg?.callFrom || '')
						break
					case 'callTo':
						comparison = (a.callLeg?.callTo || '').localeCompare(b.callLeg?.callTo || '')
						break
					case 'queueTime':
						comparison = a.queue_start_epoch - b.queue_start_epoch
						break
					case 'flow':
						comparison = (
							a.callLeg?.flowHistory?.flows && a.callLeg.flowHistory.flows.length > 0
								? a.callLeg.flowHistory.flows[a.callLeg.flowHistory.flows.length - 1]?.flow?.name || ''
								: ''
						).localeCompare(
							b.callLeg?.flowHistory?.flows && b.callLeg.flowHistory.flows.length > 0
								? b.callLeg.flowHistory.flows[b.callLeg.flowHistory.flows.length - 1]?.flow?.name || ''
								: ''
						)
						break
					case 'reference':
						comparison = (a.flow_node || a.shared_ref || '').localeCompare(
							b.flow_node || b.shared_ref || ''
						)
						break
				}
				return this.sortDirection === 'asc' ? comparison : -comparison
			})
		},
		selectedFlowData() {
			const call = this.callLegs.find((call) => call.id === this.selectedFlow)
			if (call) {
				this.setLastSelectedFlow(call)
				return call
			} else {
				return this.lastCallData
			}
		},
		selectedFlowIsCompleted() {
			return !this.callLegs.find((call) => call.id === this.selectedFlow)
		}
	},
	methods: {
		formatQueueTime(epoch) {
			const now = Date.now()
			const seconds = Math.floor((now - epoch) / 1000)
			return this.$global.formatDuration(seconds)
		},
		formatStartTime(epoch) {
			return new Date(epoch).toLocaleTimeString()
		},
		showFlowHistory(call) {
			console.log(this.callLegs, call)
			this.selectedFlow = call.id
		},
		setLastSelectedFlow(call) {
			if (call) this.lastCallData = JSON.parse(JSON.stringify(call))
		},
		sortBy(field) {
			if (this.sortField === field) {
				this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
			} else {
				this.sortField = field
				this.sortDirection = 'asc'
			}
		},
		getSortIcon(field) {
			if (this.sortField !== field) return ''
			return this.sortDirection === 'asc' ? 'fa-light fa-chevron-up' : 'fa-light fa-chevron-down'
		}
	}
}
</script>
